import { useContext, useMemo } from 'react';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { StyledFlex, SwitchThemeContext, useViewport } from '@tryhackme/thm-ui-components';
import { RoomTask } from 'src/common/interfaces/tasks';
import { ToolTip } from 'src/common/components';
import { BREAKPOINTS } from 'src/common/constants/breakpoints';
import { ThemeColorMode } from 'src/common/enums';
import { useResetUserProgressMutation } from 'src/features/room/room.slice';
import { StyledCorrectAnswerText, StyledRoomFooterWrapper, StyledTaskProgressStatus, StyledTasksProgressWrapper, StyledTaskTooltipText, StyledCorrectAnswerIcon, StyledCorrectAnswerMessageWrapper, StyledLoading } from './room-footer.styles';
import { RoomFooterProps, TaskProgressStatus } from './room-footer.types';
export const RoomFooter = ({
  tasks,
  isSplitScreenOpen,
  currentTask
}: RoomFooterProps) => {
  const {
    theme
  } = useContext(SwitchThemeContext);
  const {
    width
  } = useViewport();
  const isDesktop = width > BREAKPOINTS.DESKTOP;
  const isTablet = width > BREAKPOINTS.TABLET;
  const isDarkMode = theme === ThemeColorMode.DARK;
  const isTabletAndNotSplitScreen = isTablet && !isSplitScreenOpen;
  const [, {
    isLoading: isResetRoomProgressLoading
  }] = useResetUserProgressMutation({
    fixedCacheKey: 'shared-reset-progress'
  });
  const sortedTasks = useMemo(() => [...(tasks || [])].sort((a, b) => a.taskNo - b.taskNo), [tasks]);
  const hasAnsweredCorrectly = !!currentTask?.questions[0]?.progress?.correct;
  if (isResetRoomProgressLoading) {
    return <StyledLoading />;
  }
  const getTaskStatus = (task: RoomTask) => {
    const isCompleted = task.questions.every(q => !!q.progress?.correct);
    if (isCompleted) {
      return TaskProgressStatus.COMPLETED;
    }
    if (task.taskNo === currentTask?.taskNo) {
      return TaskProgressStatus.IN_PROGRESS;
    }
    return TaskProgressStatus.NOT_STARTED;
  };
  const renderCorrectAnswerMessage = () => <StyledCorrectAnswerMessageWrapper $hasAnsweredCorrectly={hasAnsweredCorrectly} data-sentry-element="StyledCorrectAnswerMessageWrapper" data-sentry-component="renderCorrectAnswerMessage" data-sentry-source-file="room-footer.tsx">
      <StyledCorrectAnswerIcon icon={faCircleCheck} $isDarkMode={isDarkMode} data-sentry-element="StyledCorrectAnswerIcon" data-sentry-source-file="room-footer.tsx" />
      <StyledCorrectAnswerText $isDarkMode={isDarkMode} data-sentry-element="StyledCorrectAnswerText" data-sentry-source-file="room-footer.tsx">Woop woop! Your answer is correct.</StyledCorrectAnswerText>
    </StyledCorrectAnswerMessageWrapper>;
  return <StyledRoomFooterWrapper $hasAnsweredCorrectly={hasAnsweredCorrectly} $isTabletAndNotSplitScreen={isTabletAndNotSplitScreen} $isDarkMode={isDarkMode} data-testid="room-footer" data-sentry-element="StyledRoomFooterWrapper" data-sentry-component="RoomFooter" data-sentry-source-file="room-footer.tsx">
      {(!isDesktop || isSplitScreenOpen) && renderCorrectAnswerMessage()}
      <StyledFlex data-sentry-element="StyledFlex" data-sentry-source-file="room-footer.tsx">
        <StyledTasksProgressWrapper data-testid="task-progress" data-sentry-element="StyledTasksProgressWrapper" data-sentry-source-file="room-footer.tsx">
          {sortedTasks.map(task => {
          const taskStatus = getTaskStatus(task);
          return <ToolTip key={task._id} sideOffset={0} toolTipText={<StyledTaskTooltipText>
                    <span>Task {task.taskNo}</span>
                    <span>{task.title}</span>
                  </StyledTaskTooltipText>}>
                <StyledTaskProgressStatus key={task._id} $status={taskStatus} data-state={taskStatus} />
              </ToolTip>;
        })}
        </StyledTasksProgressWrapper>
        {isDesktop && !isSplitScreenOpen && renderCorrectAnswerMessage()}
        <div id="room-footer-submit-btn" />
      </StyledFlex>
    </StyledRoomFooterWrapper>;
};